// extracted by mini-css-extract-plugin
export var skiptoinvisible = "SkipToContent-module--skiptoinvisible--0ba8d";
export var skiptovisible = "SkipToContent-module--skiptovisible--b162a";